import { render, staticRenderFns } from "./contentCom.vue?vue&type=template&id=572cb33e&scoped=true"
import script from "./contentCom.vue?vue&type=script&lang=js"
export * from "./contentCom.vue?vue&type=script&lang=js"
import style0 from "./contentCom.vue?vue&type=style&index=0&id=572cb33e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572cb33e",
  null
  
)

export default component.exports